<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import EventDetail from 'components/EventDetail'
import iframeLib from 'lib/iframe'
import IFRAME_MESSAGE_TYPES from 'shared/constants/iframeMessageTypes'
import config from 'src/config'
import iframeWidgetBaseMixin from 'mixins/iframeWidgetBase'
import store from 'src/store'
import * as mutationTypes from 'store/mutationTypes'

export default {
  name: 'event-detail-widget',
  mixins: [iframeWidgetBaseMixin],
  components: {
    EventDetail,
  },
  computed: {
    ...mapState({
      items: (state) => state.checkout.items,
    }),
  },
  data() {
    let theme = this.$route.query.theme

    //TODO: doing this because Holy Cow is the only one using this widget right now and they need the dark theme,
    //should update their site if we can
    if (!theme) theme = 'theme-dark'

    return {
      theme,
      eventId: this.$route.query.eventId,
      buttonText: this.$route.query.buttonText,
      buttonBgColor: this.$route.query.buttonBgColor,
      buttonTextColor: this.$route.query.buttonTextColor,
    }
  },
  methods: {
    onScrollTop() {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.WIDGET_SCROLL_TOP,
          iframeId: this.iframeId,
        },
        {
          parent: true,
        }
      )
    },
    onUpdated() {
      this.publishDimensions()
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.START_CHECKOUT) {
        iframeLib.publish(
          {
            name: config.IFRAME_MESSAGE_NAME,
            type: IFRAME_MESSAGE_TYPES.CHECKOUT,
            iframeId: this.iframeId,
            data: {
              items: this.items,
            },
          },
          {
            parent: true,
          }
        )

        this.$store.dispatch('clearCheckoutCartItems')
      }
    },
  },
  created() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/EventDetail/index.vue